import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useParams } from "react-router-dom";
import Loader from "@componentsShared/Loader/Loader";
import MobileHeader1 from "@/_LayoutsRelated/mobileHeaders/mobileHeader1/MobileHeader1";
import stl from "./TrackingCheckoutStepDetails.module.css";
import { deleteDocuments as _deleteDocuments, deleteFileObject as _deleteFileObject, filterFieldsWithFiles, handleFileChange } from "../../utls";
import StepBody from "@/pages/tracking/components/SharedComponents/StepDetailsComponent_TS/StepBody/StepBody";
import StepDescription from "@/pages/tracking/components/SharedComponents/StepDetailsComponent_TS/StepDescription/StepDescription";
import RemainingPaymentComponent from "@/_MiniApps/RemainingPaymentComponent/RemainingPaymentComponent";
import useHelpers from "@hooks/useHelpers";
import useApi from "@hooks/useApi";
import { api__getTrackingStepDetails } from "@/apis/orderTracking/api__getOrderTracking";
import useButtonLoading from "@hooks/useButtonLoading";
var TrackingCheckoutStepDetails = function TrackingCheckoutStepDetails() {
  var _details$step_desc, _details$step_body, _details$step_body$da, _details$step_body2, _details$step_body2$d, _details$step_body3, _details$step_body3$d, _details$step_body4, _details$step_body4$d, _details$step_body4$d2, _details$step_body4$d3, _details$step_body5, _details$step_body5$d, _details$step_body5$d2, _details$step_body5$d3, _details$step_desc2, _details$step_desc3, _details$step_desc4;
  var params = useParams();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  //-------------------------------------------------------------------
  var orderId = params.orderId,
    stepNum = params.stepNum;
  var buttonLoading = useButtonLoading();
  var _useApi = useApi([orderId], function () {
      return api__getTrackingStepDetails({
        orderId: orderId,
        stepNum: stepNum,
        isFinance: false
      });
    }),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    details = _useApi2[2];
  var _ref = details || {},
    sadad = _ref.sadad,
    hasSadad = _ref.hasSadad,
    sadadError = _ref.sadadError;
  if (error) {
    navigateTo("/page404", {
      ref: "order-not-found1"
    });
  }

  //-------------------------------------------------------------------
  var _useState = useState({}),
    fileObjects = _useState[0],
    setFileObjects = _useState[1];
  var _useState2 = useState({}),
    preSignData = _useState2[0],
    setPreSignData = _useState2[1];
  var _useState3 = useState([]),
    uploadDocumentsData = _useState3[0],
    setUploadDocumentsData = _useState3[1];
  //-------------------------------------------------------------------
  useEffect(function () {
    var fieldsWithFiles = filterFieldsWithFiles(details);
    setUploadDocumentsData(fieldsWithFiles);
  }, [details]);
  if (loading) return /*#__PURE__*/React.createElement(Loader, null);
  return /*#__PURE__*/React.createElement(Layout, {
    headHideLinks: true,
    authenticationMsg: true,
    mainClass: "",
    linksForSearch: true,
    hideOrangeHeadBtn: true,
    disableLoader: true,
    hideAppBanner: true,
    loading: true,
    hideHeaderOnmobile: true,
    custommobileHeader: /*#__PURE__*/React.createElement(MobileHeader1, {
      title: details === null || details === void 0 ? void 0 : (_details$step_desc = details.step_desc) === null || _details$step_desc === void 0 ? void 0 : _details$step_desc.title,
      buttonFunction: function buttonFunction() {
        navigateTo("/tracking-checkout-details/".concat(orderId));
      },
      className: details !== null && details !== void 0 && (_details$step_body = details.step_body) !== null && _details$step_body !== void 0 && (_details$step_body$da = _details$step_body.data) !== null && _details$step_body$da !== void 0 && _details$step_body$da.remaining_data ? stl.greenBackGround : ""
    })
  }, Object.keys(details).length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: stl.trackingStepContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.trackingStepCardContainer
  }, details !== null && details !== void 0 && (_details$step_body2 = details.step_body) !== null && _details$step_body2 !== void 0 && (_details$step_body2$d = _details$step_body2.data) !== null && _details$step_body2$d !== void 0 && _details$step_body2$d.remaining_data ? /*#__PURE__*/React.createElement(RemainingPaymentComponent, {
    isCash: true,
    order: details === null || details === void 0 ? void 0 : (_details$step_body3 = details.step_body) === null || _details$step_body3 === void 0 ? void 0 : (_details$step_body3$d = _details$step_body3.data) === null || _details$step_body3$d === void 0 ? void 0 : _details$step_body3$d.remaining_data,
    sadad: sadad,
    hasSadad: hasSadad,
    sadadError: sadadError,
    banks: details === null || details === void 0 ? void 0 : (_details$step_body4 = details.step_body) === null || _details$step_body4 === void 0 ? void 0 : (_details$step_body4$d = _details$step_body4.data) === null || _details$step_body4$d === void 0 ? void 0 : (_details$step_body4$d2 = _details$step_body4$d.remaining_data) === null || _details$step_body4$d2 === void 0 ? void 0 : (_details$step_body4$d3 = _details$step_body4$d2.paymentOptions) === null || _details$step_body4$d3 === void 0 ? void 0 : _details$step_body4$d3.banks,
    enableAllPayments: details === null || details === void 0 ? void 0 : (_details$step_body5 = details.step_body) === null || _details$step_body5 === void 0 ? void 0 : (_details$step_body5$d = _details$step_body5.data) === null || _details$step_body5$d === void 0 ? void 0 : (_details$step_body5$d2 = _details$step_body5$d.remaining_data) === null || _details$step_body5$d2 === void 0 ? void 0 : (_details$step_body5$d3 = _details$step_body5$d2.paymentOptions) === null || _details$step_body5$d3 === void 0 ? void 0 : _details$step_body5$d3.enabled,
    buttonLoading: buttonLoading,
    title: details === null || details === void 0 ? void 0 : (_details$step_desc2 = details.step_desc) === null || _details$step_desc2 === void 0 ? void 0 : _details$step_desc2.title,
    id: orderId,
    date: details === null || details === void 0 ? void 0 : (_details$step_desc3 = details.step_desc) === null || _details$step_desc3 === void 0 ? void 0 : _details$step_desc3.date,
    backFromTracking: true,
    stepStatus: details === null || details === void 0 ? void 0 : (_details$step_desc4 = details.step_desc) === null || _details$step_desc4 === void 0 ? void 0 : _details$step_desc4.status
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StepDescription, {
    details: details,
    stepNum: stepNum
  }), /*#__PURE__*/React.createElement(StepBody, {
    details: details,
    orderId: orderId,
    preSignData: preSignData,
    fileObjects: fileObjects,
    uploadDocumentsData: uploadDocumentsData,
    buttonLoading: buttonLoading,
    stepNum: stepNum,
    onFileChange: function onFileChange(file, field) {
      return handleFileChange(file, field, setFileObjects, setPreSignData, setUploadDocumentsData);
    },
    deleteFileObject: function deleteFileObject(field) {
      return _deleteFileObject(field, setFileObjects);
    },
    setFileObjects: setFileObjects,
    deleteDocuments: function deleteDocuments(field) {
      return _deleteDocuments(field, setUploadDocumentsData);
    }
  })))) : null);
};
export default TrackingCheckoutStepDetails;